import React from "react";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Card, CardContent, Box, Skeleton, Typography } from "@mui/material";

const darkTheme = createTheme({
    palette: {
        mode: 'dark',
    },
    components: {
        MuiSkeleton: {
            styleOverrides: {
                root: {
                    backgroundColor: '#2A2A2A', // Base color
                },
                pulse: {
                    '&::after': {
                        background: 'linear-gradient(90deg, #2A2A2A, #3C3C3C)', // Highlight animation
                    },
                },
            },
        },
    },
});

const BoosterLoanSkeleton: React.FC = () => {
    return (
        <>
            {Array.from({ length: 5 }).map((_, index) => (
                <ThemeProvider theme={darkTheme} key={index}>
                    <Card
                        className="stock card"
                    >
                        <CardContent className="text-white" sx={{ padding: '16px !important', '&:last-child': { paddingBottom: '16px !important' } }}>
                            <Box display="flex" alignItems="center" gap={2} mb={1}>
                                {/* Match LoadingCards circular sizing: height 30, width 40 */}
                                <Skeleton variant="circular" height="30px" width="40px" />
                                <Box width="100%">
                                    <Typography variant="body2" fontWeight={600} mb={0} sx={{ fontSize: 16 }}>
                                        <Skeleton />
                                    </Typography>
                                    <Typography variant="caption" >
                                        <Skeleton width="40%" />
                                    </Typography>
                                </Box>
                            </Box>

                            {/* Amount/title similar sizing to LoadingCards */}
                            <Typography variant="body1" fontWeight="bold" mb="4px" sx={{ fontSize: 20 }}>
                                <Skeleton width="60%" height={28} />
                            </Typography>

                            <Typography fontSize='12px' mb={1.5} >
                                <Skeleton width="60%" />
                            </Typography>

                            <Box mb={2}>
                                <Skeleton variant="rectangular" height={6} width="100%" sx={{ borderRadius: 2 }} />
                            </Box>

                            <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ padding: '12px', backgroundColor: 'rgba(255,255,255,0.02)', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.03)' }}>
                                <Box display="flex" flexDirection="column" alignItems="flex-start">
                                    <Typography variant="body2" fontWeight={600} mb="2px" sx={{ fontSize: '14px' }}>
                                        <Skeleton width={100} />
                                    </Typography>
                                    <Typography variant="caption" mb={0} color="#4A7AF2" sx={{ fontWeight: 500 }}>
                                        <Skeleton width={80} />
                                    </Typography>
                                </Box>
                                <Skeleton variant="rounded" width={36} height={36} sx={{ borderRadius: 2 }} />
                            </Box>
                        </CardContent>
                    </Card>
                </ThemeProvider>
            ))}
        </>
    );
};

export default BoosterLoanSkeleton;
